import create from 'zustand';

import { getProposals } from '../../api/proposal';
import { IProposal } from '../../interfaces/proposal';
import { processErrorMessage } from '../../utils/processErrorMessage';

interface ProposalsState {
  total: number;
  proposals: IProposal[] | null;
  loading: boolean;
  error?: any;
  currentPage: number;

  getProposals: (payload?: Record<string, any>) => Promise<void>;
  setCurrentPage: (page: number) => void;
}

export const useProposalsStore = create<ProposalsState>((set) => ({
  total: 0,
  proposals: null,
  loading: false,
  error: null,
  currentPage: 1,

  getProposals: async (payload) => {
    set({ loading: true });

    try {
      const { entries: proposals, total } = await getProposals(payload);
      set({ proposals, total });
    } catch (err) {
      set({ error: processErrorMessage(err) });
    }

    set({ loading: false });
  },

  setCurrentPage: (page) => {
    set({ currentPage: page });
  }
}));
